var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Input, Loader, ModalWindow } from '../../components';
import { useHttp } from '../../hooks/useHttp';
import { AppContext } from '../../hooks/context';
import styles from './style.module.scss';
const DeleteRegisterPage = () => {
    const { t } = useTranslation();
    const { request } = useHttp();
    const { user, setAuth } = React.useContext(AppContext);
    const [value, setValue] = React.useState('');
    const [noDate, setNoDate] = React.useState(false);
    const [students, setStudents] = React.useState([]);
    const [discipline, setDiscipline] = React.useState([]);
    const [modal, setModal] = React.useState(false);
    const [studentFio, setStudentFio] = React.useState('');
    const [loader, setLoader] = React.useState({
        search: false,
        modal: false,
        deleteDiscipline: false,
    });
    const [idGroup, setIdGroup] = React.useState(null);
    const [isPatchStudents, transitionStudent] = React.useTransition();
    const [isPatchDiscipline, transitionDiscipline] = React.useTransition();
    const change = (e) => {
        setValue(e.target.value);
    };
    const searchApi = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (value.length) {
            setStudents([]);
            setLoader(Object.assign(Object.assign({}, loader), { search: true }));
            const { data, auth } = yield request(`/students/search`, 'POST', {
                fio: value,
                AVN_login: user === null || user === void 0 ? void 0 : user.AVN_login,
                visible: user === null || user === void 0 ? void 0 : user.visible,
            });
            if (!auth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            if (data.length) {
                setNoDate(false);
                setLoader(Object.assign(Object.assign({}, loader), { search: false }));
                transitionStudent(() => {
                    setStudents(data);
                });
                return;
            }
            setLoader(Object.assign(Object.assign({}, loader), { search: false }));
            return setNoDate(true);
        }
        toast.warn(t('warnInput'));
    });
    const showModal = (id_student, fio, id_group) => {
        document.body.style.overflowY = 'hidden';
        setStudentFio(fio);
        setModal(true);
        setIdGroup(id_group);
        getDiscipline(id_student, id_group);
    };
    const getDiscipline = (id_student, id_group) => __awaiter(void 0, void 0, void 0, function* () {
        setLoader(Object.assign(Object.assign({}, loader), { modal: true }));
        const res = yield request(`/students/discipline/${id_student}/${id_group}`, 'POST');
        if (!res.auth) {
            setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
            return;
        }
        transitionDiscipline(() => {
            setDiscipline(res.data);
        });
        setLoader(Object.assign(Object.assign({}, loader), { modal: false }));
    });
    const hideModal = () => {
        document.body.style.overflowY = 'visible';
        setModal(false);
    };
    const deleteDisciplineApi = (id, id_student) => __awaiter(void 0, void 0, void 0, function* () {
        if (id) {
            setLoader(Object.assign(Object.assign({}, loader), { deleteDiscipline: true }));
            const { data, type, auth, message } = yield request(`/students/discipline-delete/${user === null || user === void 0 ? void 0 : user.id_AVN_user}`, 'POST', { id: [id] });
            if (!auth) {
                setAuth ? setAuth({ id_role: null, isAuth: false, id_user: null, id_avn_user: null }) : null;
                return;
            }
            toast[type](message);
            setLoader(Object.assign(Object.assign({}, loader), { deleteDiscipline: false }));
            return getDiscipline(id_student, idGroup);
        }
        toast.warn(t('chooseDiscipline'));
    });
    const studentsMemo = React.useMemo(() => {
        return students.map((item, index) => (_jsxs("tr", { children: [_jsx("th", { children: index + 1 }), _jsx("td", { children: item.s_fio }), _jsx("td", { children: item.p20 }), _jsx("td", Object.assign({ className: "text-center" }, { children: _jsx("i", { style: { cursor: 'pointer' }, title: t('edit'), className: "fa-solid fa-pen-to-square text-primary", onClick: showModal.bind(null, item.id_student, item.s_fio, item.id_group) }) }))] })));
    }, [students]);
    return (_jsxs(_Fragment, { children: [modal && (_jsx(ModalWindow, { hideModal: hideModal, deleteDisciplineApi: deleteDisciplineApi, modalLoader: loader.modal, deleteLoader: loader.deleteDiscipline, isPatch: isPatchDiscipline, discipline: discipline, studentFio: studentFio })), _jsxs("div", Object.assign({ className: styles.container }, { children: [_jsx(NavLink, Object.assign({ to: "/avn33/home" }, { children: _jsx("i", { style: { fontSize: '30px' }, className: "fa-solid fa-arrow-left" }) })), _jsx("h2", Object.assign({ className: "text-center", style: { marginBottom: '20px' } }, { children: t('searchStudent') })), _jsxs("form", Object.assign({ onSubmit: searchApi, className: "w-75 d-flex m-auto gap-4 align-items-center" }, { children: [_jsx(Input, { max: 100, value: value, change: change, placeholder: t('searchFio'), type: "search" }), _jsx("div", Object.assign({ style: { width: '120px' } }, { children: _jsxs("button", Object.assign({ className: "btn btn-primary" }, { children: [_jsx("i", { className: "fa-solid fa-magnifying-glass", style: { marginRight: '8px' }, onClick: searchApi }), t('search')] })) }))] })), noDate && _jsx("h5", Object.assign({ className: "text-center mt-2" }, { children: t('noData') })), _jsx("div", Object.assign({ className: "mt-2" }, { children: loader.search || isPatchStudents ? (_jsx("div", Object.assign({ className: "d-flex justify-content-center align-items-center mt-5" }, { children: _jsx(Loader, { type: "text-primary" }) }))) : (_jsxs("table", Object.assign({ className: "table" }, { children: [_jsx("thead", Object.assign({ className: "bg-light" }, { children: _jsxs("tr", { children: [_jsx("th", { children: "\u2116" }), _jsx("th", { children: t('fio') }), _jsx("th", { children: "\u0413\u0440\u0443\u043F\u043F\u0430" }), _jsx("th", Object.assign({ className: "text-center" }, { children: t('action') }))] }) })), _jsx("tbody", { children: studentsMemo })] }))) }))] }))] }));
};
export default DeleteRegisterPage;
